import { defineMessages } from 'react-intl'

export default defineMessages({
    placeLabel: {
        defaultMessage: 'Dónde',
    },
    placePlaceholder: {
        defaultMessage: 'Ej.: Calle, ciudad...',
    },
    startDateLabel: {
        defaultMessage: 'Entrada',
    },
    startDatePlaceholder: {
        defaultMessage: 'Entrada',
    },
    endDateLabel: {
        defaultMessage: 'Salida',
    },
    endDatePlaceholder: {
        defaultMessage: 'Salida',
    },
    allFilterLabel: {
        defaultMessage: 'Todos los parkings',
    },
    airportsFilterLabel: {
        defaultMessage: 'Aeropuertos',
    },
})
